import { NavLink, useLocation } from 'react-router-dom';
import { useStudio } from '../studios/StudioContext';
import './studioNav.css';

// Site nav for studios without their own website (config flags.siteNav), e.g. the demo.
// Hidden inside embeds and on the check-in kiosk.
export default function StudioNav() {
  const studio = useStudio();
  const { pathname } = useLocation();
  const id = studio?.studioId;
  if (!id || /\/(embed|checkin)\/?$/.test(pathname)) return null;

  const links = [
    { to: `/${id}`,             label: 'Schedule', end: true },
    { to: `/${id}/videos`,      label: 'Videos' },
    { to: `/${id}/my-bookings`, label: 'My Bookings' },
    { to: `/${id}/admin`,       label: 'Admin' },
  ];
  const linkClass = ({ isActive }) => `studio-nav-link${isActive ? ' active' : ''}`;

  return (
    <nav className="studio-nav" aria-label="Studio">
      <NavLink to={`/${id}`} end className="studio-nav-brand">{studio.studioName}</NavLink>
      <div className="studio-nav-links">
        {links.map(l => (
          <NavLink key={l.to} to={l.to} end={l.end} className={linkClass}>{l.label}</NavLink>
        ))}
      </div>
    </nav>
  );
}
